import {AddGiftCard, AddGiftCardCallback, AddGiftCardContractModel} from "@next/eventservice"
import {ShoppingBagApiPost} from "../../api/shoppingbag"

const getBagESB = new AddGiftCard()
const getBagCallbackESB = new AddGiftCardCallback()

export const SubscribeToShoppingBagAddGiftCard = (siteUrl: string) => {
    getBagESB.subscribe(data => {
        LoadShoppingBagApiData(siteUrl, data)
    })
}

// legacy model for MVC to work
class BagAddGiftCardApiModel {
    id = ""
    amountOption = ""
    firstName = ""
    lastName = ""
    addressLine1 = ""
    addressLine2 = ""
    addressLine3 = ""
    addressLine4 = ""
    addressLine5 = ""
    postCode = ""
    message = ""
    deliveryDate = ""
    deliveryOption = ""
    deliveryCharge = ""
    mediacode = ""
}

const LoadShoppingBagApiData = (url: string, data: AddGiftCardContractModel) => {
    const apiModel = new BagAddGiftCardApiModel()
    apiModel.id = data.id
    apiModel.amountOption = data.amountOption
    apiModel.firstName = data.firstName
    apiModel.lastName = data.lastName
    apiModel.addressLine1 = data.addressLine1
    apiModel.addressLine2 = data.addressLine2
    apiModel.addressLine3 = data.addressLine3
    apiModel.addressLine4 = data.addressLine4
    apiModel.addressLine5 = data.addressLine5
    apiModel.postCode = data.postCode
    apiModel.message = data.message
    apiModel.deliveryDate = data.deliveryDate
    apiModel.deliveryOption = data.deliveryOption
    apiModel.deliveryCharge = data.deliveryCharge
    apiModel.mediacode = data.mediacode

    ShoppingBagApiPost(apiModel, `${url}/bag/AddGiftCard`, getBagCallbackESB, data.eventId)
}
